import { render } from "./privacy-text.vue?vue&type=template&id=7872540e"
import script from "./privacy-text.vue?vue&type=script&lang=js"
export * from "./privacy-text.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kurlov/WebstormProjects/2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__